var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subType == 'lcps')?_c('div',{attrs:{"id":"videoLcps"}},[_c('video',{ref:"rtcVideoID",attrs:{"id":"rtcVideoID","preload":"auto","controls":"","autoplay":""}})]):_c('div',{attrs:{"id":"MPSplayer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }